import {gql} from "@apollo/client";

export const LoginUser = gql`
    mutation Login($userName: String!, $userPassword: String!) {
        login(userName: $userName, userPassword: $userPassword) {
            token
            user {
                userEmail
                userId
                userName
                userRole
                lastHostedAdventure
                lastPlayedAdventure
            }
        }
    }
`

export const TokenLogin = gql`
    mutation loginViaToken($token: String!) {
        loginViaToken(token: $token) {
            user {
                userEmail
                userId
                userName
                userRole
                lastHostedAdventure
                lastPlayedAdventure
            }
        }
    }
`

export const SignUp = gql`
    mutation signUp ($userEmail: String!, $userName: String!, $userPassword: String!) {
        signup(userRole: 0, userName: $userName, userEmail: $userEmail, userPassword: $userPassword) {
            token
            user {
                userEmail
                userName
                userId
                userRole
            }
        }
    }
`